import Vue from "vue";
import Router from "vue-router";

import appRoutes from "@/routes/app-routes.js";
import adminRoutes from "@/routes/admin-routes.js";
import unauthenticatedRoutes from "@/routes/unauthenticated-routes.js";

Vue.use(Router);

const routes = [...appRoutes, ...unauthenticatedRoutes, ...adminRoutes];

const router = new Router({
  hash: false,
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  const requiresAuth = to.meta.requiresAuth;
  const user = JSON.parse(localStorage.getItem("user"));

  if (requiresAuth) {
    if (!user || !user.role) {
      return next({ path: "/login", query: { redirect: to.fullPath } });
    }
    if (requiresAuth.length && !requiresAuth.includes(user.role)) {
      return next({ path: "/", query: { redirect: to.fullPath } });
    }
    return next();
  } else {
    return next();
  }
});

export default router;
